<template>
  <div class="stockProduct_single">
      <dialogPlugin :showProduct.sync='showProduct'></dialogPlugin>
      <dialogPlugin :showErrorDeleteItem.sync='showErrorDeleteItem' :listErrorOptions="listErrorOptions"></dialogPlugin>
      <dialogPlugin :showshopOption.sync='showshopOption' @oneImport="oneImport"></dialogPlugin>
       <el-dialog
        :title="$t('other.a2618')"
        :visible.sync="transproductDia"
        width="30%"
        >
        <el-select v-model="targetStoreid" :placeholder="$t('other.a2619')" >
            <el-option v-for="item in storeOptions" :key="item.storeId" :label="item.storeName" :value="item.storeId">
            </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
            <el-button size='small' type="primary" @click="transproductDia = false">{{$t('other.a106')}}</el-button>
            <el-button size='small' type="primary" @click="transformPorduct()">{{$t('other.a274')}}</el-button>
        </span>
        </el-dialog>

      <div class="vkfhikf">
          <div class="title">{{$t('other.a2620')}}（{{pageTotal}}{{$t('other.a1326')}}）</div>
           <div class="store_header">
             {{$t('other.a653')}}：
             <span :class="{'btn':true,'active':storeId == btn.storeId}" v-for="(btn,index) in storeOptions" :key="index" @click="handle(btn,index)">{{btn.storeName}}</span>
            </div>
            <div class="weconkf">
                <div style="display:flex;align-items: center">
                    <el-checkbox class="menu" v-model="checked">{{$t('other.a2520')}}({{alltotal.length}})</el-checkbox>
                    <el-dropdown class="menu" size="mini" v-if="vipLevel == 0">
                        <el-button size="medium" type="primary">
                            {{$t('other.a2521')}} <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="massMoveIn()">{{$t('other.a2611')}}</el-dropdown-item>
                            <el-dropdown-item @click.native="transproductDia=true">{{$t('other.a2621')}}</el-dropdown-item>
                            <el-dropdown-item @click.native="massDeletd()">{{$t('other.a2523')}}</el-dropdown-item>
                            <!-- <el-dropdown-item>批量更换所属SKU</el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-dropdown class="menu" size="mini" v-if="vipLevel == 0">
                        <el-button size="medium" type="primary">
                            {{$t('other.a2622')}} <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="insertProduct()"> {{$t('other.a2525')}}</el-dropdown-item>
                            <el-dropdown-item @click.native="goToInsertGoods()">{{$t('other.a2526')}}</el-dropdown-item>
                            <!-- <el-dropdown-item>批量更换所属SKU</el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <el-button v-if="vipLevel == 0" class="menu" size="medium" type="primary" @click="insertProduct()">导入线上产品</el-button> -->
                    <el-button class="menu" size="medium" type="primary" @click="exportxml()">{{$t('other.a2613')}}</el-button>
                    <!-- <el-button class="menu" size="medium" type="primary" @click="showshopOption=true">{{$t('other.a2626')}}</el-button> -->
                </div>
                <div style="margin-right:15px">
                    <el-input size="medium" style="width:250px;margin-right:5px" v-model="input" :placeholder="$t('other.a1327')"></el-input>
                    <el-button size="medium" tyle="margin-right:5px" type="primary" icon="el-icon-search" @click="search()">{{$t('other.a27')}}</el-button>
                </div>
            </div>
      </div>

      <div v-if="!overDataList.length" class="nodata">{{$t('other.a247')}}</div>

       <div v-else class="overseaProduct_list">
          <div :class="{'overseaProduct_item':true,'overseaProduct_item_active':activeIndex === index} " @mouseenter="activeIndex=index" @mouseleave="activeIndex=-1"  v-for="(item,index) in overDataList" :key="index" >
              <div class="lvinf">
                <el-checkbox v-model="item.checked"></el-checkbox>
                <span class="createTime">{{item.createTime}}</span>
              </div>
              <div class="ovjknfk" @click="viewMore(item)">
                  <div class="pic_box">
                  <img style="width:100%" :src="item.image ? item.image : item.storeItems[0].image"  />
                    </div>
                    <div class="title_overseaProduct">{{item.groupName}}</div>
                    <div class="item_desc_parentsku">{{$t('other.a249')}}{{item.itemSku}}</div>
                    
                    <div  class="item_desc">{{item.skuAmount}}{{$t('other.a2615')}}</div>
                    <div  class="item_desc">{{$t('other.a2614')}}：{{item.totalNum}}</div>
              </div>
              <!-- <div class="update_overseaProduct"><span :class="{'btn':true,'btn_reverse':item.agency}">{{item.agency ? '我已分销' : $t('other.a1742')}}</span></div> -->
          </div>
      </div>
      <div class="Pager">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[15, 20, 30, 100]"
            :page-size="dataParams.offset"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
        </el-pagination>
    </div>


  </div>
</template>

<script>
import utils from '../../utils/utils'
import dialogPlugin from './component/diaload'
import { showLoading, hideLoading } from '../../assets/js/loading.js'
import userStoreItemsApi from '../../api/moudles/userStoreItems'
export default {
data(){
return{
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    storeOptions:[],
    targetIndex:[],
    listErrorOptions:[],
    showErrorDeleteItem:false,
    transproductDia:false,
    targetStoreid:null,
    storeId:null,
    currentPage:null,
    dataParams:{
        addition:true,
        component:true,
        cusCode:null,
        offset:100,
        page:0,
        sellerId:null,
        storeId:null,
        userId:JSON.parse(localStorage.getItem('userInfo')).userId
    },
    pageTotal:0,
    input:null,
    overDataList:[],
    checked:false,
    activeIndex:-1,
    vipLevel:JSON.parse(localStorage.getItem('userInfo')).vipLevel,
    showProduct:false,
    showshopOption:false

}
},

components:{
    dialogPlugin
},
computed:{
    alltotal(){
        this.targetIndex=[]
        let list=this.overDataList.filter((p,index) => {
            if(p.checked){
                this.targetIndex.push(p.groupId)
                return p
            }
        })
        return list ? list : []
    },
    num(){
        let num=0
        if(this.overDataList){
            num=this.overDataList.length
        }
        return num
    },
},
watch:{
    storeId(){
        
        this.dataParams.page=0
         this.dataParams.storeId=this.storeId
         this.getOverseaData()
        
    },
    

    checked(){
        if(this.checked){
            this.overDataList.forEach(p => {
                p.checked=true
            })
        }else{
            this.overDataList.forEach(p => {
                p.checked=false
            })
        }
    },
    input(){
        if(!this.input){
            this.dataParams.cusCode=null
            this.getOverseaData()
        }
    },
},
created(){
    this.init()

},
methods:{

    viewMore(item){
        console.log(item)
        this.$router.push({
            path:'/stockProduct/productDetail',
            query:{
                groupId:item.groupId,
                type:2
            }
        })
    },

    goToInsertGoods(){
      this.$router.push({path:'/createProduct',query:{
        from: JSON.stringify(this.$route.path),
        storeId:JSON.stringify(this.storeId),
        addition:JSON.stringify(true),
        components:JSON.stringify(true)
      }})
    },
    
    search(){
        this.dataParams.cusCode=this.input
        this.getOverseaData()
    },
    removeItem(){
        if(this.targetIndex){
            this.targetIndex.forEach((p) => {
                this.overDataList.forEach((i,index) => {
                    if(i.groupId == p){
                        i.checked=false
                        this.overDataList.splice(index,1)
                    }
                })
            })
        }
    },
    cancelTarget(){
        this.overDataList.forEach(p => {
            p.checked=false
        })
    },
    exportxml(){
        userStoreItemsApi
        .test()
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    oneImport(data){
        console.log(data)
        userStoreItemsApi
        .initStoreItem({
            shopIds:[data],
            storeId:this.storeId,
            userId:this.userId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        let text=this.$t('other.a2616')
        this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a955'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {})
        }else{
        this.$message.warning(res.msg)
        }
        })
    },
    massDeletd(){
            let arr=[]
            let num =0
            this.alltotal.forEach(i => {
                i.storeItems.forEach(p => {
                    arr.push({
                        cusCode:p.cusCode,
                        userId:this.userId,
                        storeId:i.storeId
                    })

                })
            })

            

            console.log(arr)
        let desc=this.$t('other.a2587') + arr.length + this.$t('other.a2588')
        this.$confirm(desc, this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {
                 this.listErrorOptions=[]
                userStoreItemsApi
                .massDeleteStoreItem(arr)
                .then(res => {
                    if(res.code === 200){
                        this.cancelTarget()
                        res.data.forEach(p => {
                            if(p.code == 0){
                            
                            }else{
                               
                                this.listErrorOptions.push({
                                    cusCode:p.cusCode,
                                    desc:p.msg,
                                    storeItem:p.storeItem
                                })
                                this.showErrorDeleteItem=true
                                console.log('删除失败的库存产品',this.listErrorOptions)
                                
                            }
                        })

                        if(!this.listErrorOptions.length){
                            this.$message.success(this.$t('other.a565'))
                            this.removeItem()
                        }
                    
                    }
                })
            
            })
        },

    transformPorduct(){
        console.log(this.targetStoreid)
        userStoreItemsApi
        .copyStoreItemByStore({
            storeId:this.storeId,
            targetStoreId:this.targetStoreid,
            type:0,
            userId:this.userId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a2623'))
        this.transproductDia=false
        this.targetStoreid=null
        }else{
        this.$message.warning(res.msg)
        this.targetStoreid=null
        }
        })
    },    
    massMoveIn(){
        let arr=[]
        this.alltotal.forEach((p,index) => {
            p.storeItems.forEach(i => {
                arr.push({
                    cusCode:i.cusCode,
                    component:true,
                    userId:i.userId,
                    storeId:i.storeId
                }) 	

                
            })
        })
        let text=this.$t('other.a1059') + arr.length + this.$t('other.a2585')
        this.$confirm(text, this.$t("other.a142"), {
            confirmButtonText: this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(() => {
            let total=0
            console.log(arr)
            arr.forEach(p => {
                userStoreItemsApi
                .updataComponent(p)
                .then(res => {
                    console.log(res)
                    if(res.code === 200) {
                        total +=1
                        if(total == arr.length){
                            this.$message.success(this.$t('other.a2617'))
                            this.removeItem()
                        }
                        console.log('total',total)
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
            })
        })
    },
    insertProduct(){
        console.log(this.alltotal)
        this.$router.push({
            path:'/onlineGoods',
            query:{
                storeId:this.dataParams.storeId,
                component:false
            }
        })
    },
    init(){
        let stores=JSON.parse(localStorage.getItem('userInfo')).stores
        if(stores){
            //筛选所有启用的海外仓
            for(let i=0;i<stores.length;i++){
                if(stores[i].storeType !== 4 && stores[i].isUsed){
                    this.storeOptions.push(stores[i])
                }
            }
            
            if(!this.storeOptions.length){
                this.$message.warning(this.$t('other.a258'))
                return
            }else{
                let id=utils.defaultStoreId(this.storeOptions)
                this.storeId= id ? id : this.storeOptions[0].storeId
               
                console.log(this.storeOptions,id)
            }
        }else{
            this.$message.warning(this.$t('other.a259'))
        }
    },
    handle(item,index){
        this.storeId=item.storeId
        utils.setDefalultStoreId(this.storeId)
        console.log(this.storeId)
    },
    //获取海外仓的库存产品
    getOverseaData(){
        showLoading()
        userStoreItemsApi
        .getStoreItem(this.dataParams)
        .then(res => {
            if(res.code === 200){
                console.log('海外仓库数据',res.data)
                res.data.groups.forEach(p => {
                    p.itemSku=p.itemSku ? p.itemSku : this.$t('other.a260')
                    p.createTime=utils.renderTime(p.createTime)
                    p.checked=false
                    p.totalNum=0
                    p.storeItems.forEach(i => {
                        p.totalNum+=i.storeNum
                    })
                })

                this.overDataList=res.data.groups
                this.pageTotal=res.data.count
               
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.dataParams.offset=parseInt(`${val}`)
            this.handleCurrentChange()
    },
    //显示当前第几页
    handleCurrentChange(val) {
        this.currentPage=parseInt(`${val}`)
        this.dataParams.page= `${val}` == 'undefined' ? 0 : (parseInt(`${val}`) -1) * this.dataParams.offset
        this.getOverseaData()
    },

}
}

</script>
<style lang='scss' scoped>
/deep/ .el-dropdown-menu__item{
    font-size: 22px;
    line-height: 45px;
}


.stockProduct_single{
    background: #eee;
    min-height: 100vh;
    position: relative;


    


    .ovjknfk{
        cursor: pointer;
    }


    .Pager{
		position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

    .nodata{
        position: absolute;
        left: 0;
        right: 0;
        margin:  auto;
        text-align: center;
        font-size: 20px;
        margin-top: 200px;
    }

    .lvinf{
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding:3px 8px
    }

    .createTime{
        font-size: 10px;
    }
     

    .title{
        font-size: 18px;
        font-weight: 400;;
        margin-bottom: 20px;
       
    }

    .vkfhikf{
        background-color: #fff;
        position: fixed;
        right: 0;
        left: 205px;
        z-index: 79;
        top: 50px;
    }

    .weconkf{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;

        .menu{
            margin-right: 10px;
            margin-left: 0px;
        }
    }

    .store_header{
        margin: 10px 0;
        background: #fff;
        font-size: 20px;
        border-bottom: 1px solid #909399;
        padding-bottom: 7px;
        

        .btn{
            border: 1px solid #d9d9d9;
            box-sizing: border-box;
            padding: 3px 8px;
            margin-right: 5px;
            cursor: pointer;
        }

        .active{
            color: #fff;
            background: #409eff;
        }
    }


    .overseaProduct_list{
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 50px;
        padding-top: 140px;
       
       

        .overseaProduct_item{
            box-sizing: border-box;
            margin: 8px 6px;
            background-color: #fff;
            border-radius: 5px;
             border: 1px solid #fff;

        }

        .overseaProduct_item_active{
          border: 1px solid #F56C6C;
         
        }

        .update_overseaProduct{
          
          text-align: right;
          margin: 7px 0;

          .btn{
            background-color: rgb(42, 165, 21);
            border-radius: 3px;
            padding:4px 5px;
            color: #eee;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
          }

          .btn_reverse{
             background-color: #F56C6C;
              border-radius: 3px;
              padding:4px 5px;
              color: #eee;
              font-size: 12px;
              font-weight: bold;
              cursor: pointer;
          }
        }
        
     


        .pic_box{
            width: 173px;
            height: 173px;
            overflow: hidden;
            border-radius: 5px;
            cursor: pointer;
        }
        .title_overseaProduct{
            width:148px;
            height: 1.7rem;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 12px;
            box-sizing: border-box;
            padding: 0 0 0 6px;
            
        }

        .item_desc{
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0 5px 6px;
        }

        .item_desc_parentsku{
          color: #F56C6C;
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0 5px 6px ;
          white-space: nowrap;
          
        }
    }



}
</style>